'use client';

import styles from './PrimaryLoader.module.scss';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useScrollLock } from '../../../utils/useLockScroll';

const PrimaryLoader = ({ mode = 'global', size = 40, text = '', borderWidth = 2, theme = 'dark', pageType = '' }) => {
  mode === 'global' && useScrollLock(true);

  const segmentLoader = (
    <span
      className={styles.spinner}
      style={{
        width: `${size}px`,
        minWidth: `${size}px`,
        height: `${size}px`,
        minHeight: `${size}px`,
        borderWidth: borderWidth && `${borderWidth}px`,
        borderColor: theme === 'light' ? '#fff' : '#000',
        borderBottomColor: 'transparent',
      }}
    />
  );

  const fixedLoader = (
    <div className={styles.fixedLoaderOverlay}>
      {segmentLoader}
      {text && <span className={styles.loaderText}>{text}</span>}
    </div>
  );

  const globalLoader = (
    <div className={styles.submittingOverlay}>
      {segmentLoader}
      {text && <span className={styles.loaderText}>{text}</span>}
    </div>
  );

  const globalInnerLoader = (
    <div
      className={clsx(styles.submittingOverlay, styles.submittingOverlayInner, {
        [styles[`pageType_${pageType}`]]: pageType,
      })}
    >
      {segmentLoader}
      {text && <span className={styles.loaderText}>{text}</span>}
    </div>
  );

  return {
    global: globalLoader,
    globalInner: globalInnerLoader,
    fixed: fixedLoader,
    segment: segmentLoader,
  }[mode];
};

PrimaryLoader.propTypes = {
  mode: PropTypes.oneOf(['global', 'segment', 'globalInner', 'fixed']),
  size: PropTypes.number,
  text: PropTypes.string,
  theme: PropTypes.string,
  pageType: PropTypes.string,
};

export default PrimaryLoader;
